import React from 'react';
import PropTypes from 'prop-types';
import EventCell from './EventCell';
import { segStyle } from './utils/eventLevels';
import { isSelected } from './utils/selection';

class EventRow extends React.Component {
  constructor(props) {
    super(props);
    this.rowRef = React.createRef();
  }

  componentDidMount() {
    const height = this.getRowHeight();
    if (height) {
      // Do something with the height
    }
  }

  getRowHeight = () => {
    if (this.rowRef.current) {
      return this.rowRef.current.offsetHeight;
    }
    return null;
  }

  renderEvent = (event) => {
    const {
      eventPropGetter,
      onSelect,
      selected,
      startAccessor,
      endAccessor,
      titleAccessor,
      allDayAccessor,
      start,
      end,
      eventComponent
    } = this.props;
    return (
      <EventCell
        event={event}
        eventPropGetter={eventPropGetter}
        onSelect={onSelect}
        selected={isSelected(event, selected)}
        startAccessor={startAccessor}
        endAccessor={endAccessor}
        titleAccessor={titleAccessor}
        allDayAccessor={allDayAccessor}
        slotStart={start}
        slotEnd={end}
        component={eventComponent}
      />
    );
  }

  renderSpan = (len, key, content = ' ') => {
    const { slots, onSelect,span, segments } = this.props;
    
    return (
      <div key={key} className="------- rbc-row-segment" style={segStyle(Math.abs(len), slots)} onClick={()=>{
        onSelect(segments[0]?.event)
      }}>
        {content}
      </div>
    );
  }

  render() {
    const { segments } = this.props;

    return (
      <div ref={this.rowRef} className="rbc-row">
        {segments.map((segment, index) => {
          if (segment.event) {
            return this.renderEvent(segment.event);
          } else {
            return this.renderSpan(segment.span, index);
          }
        })}
      </div>
    );
  }
}

EventRow.propTypes = {
  slots: PropTypes.number,
  end: PropTypes.instanceOf(Date),
  start: PropTypes.instanceOf(Date),
  selected: PropTypes.array,
  eventPropGetter: PropTypes.func,
  titleAccessor: PropTypes.any.isRequired,
  allDayAccessor: PropTypes.any.isRequired,
  startAccessor: PropTypes.any.isRequired,
  endAccessor: PropTypes.any.isRequired,
  eventComponent: PropTypes.elementType,
  onSelect: PropTypes.func,
  segments: PropTypes.array
};

EventRow.defaultProps = {
  segments: [],
  selected: [],
  slots: 7,
};

export default EventRow;